import(/* webpackMode: "eager" */ "/vercel/path0/src/app/funds/[slug]/page.tsx");
